module.exports = __webpack_public_path__ + "494cd07c/img/splash-icon.07a7c465.svg";